import React from 'react';
import cx from 'classnames';
import T from 'prop-types';
import { demoPageUrl, financeReportPageUrl } from '../../alchemy-static-page-urls';

const ReachedQuotaState = ({ isMobileMode }) => (
  <div className={cx('reached-quota-state', { 'app-selection-mobile-container': isMobileMode })}>
    <h2 className="reached-quota-state-header text-16 text-uppercase text-center">
      Oops! It looks like you&apos;ve reached <br /> your report limit.
    </h2>

    <div className="reached-quota-state-body">
      <div className="reached-quota-state-image" />
      <div className="reached-quota-state-contact-us">
        <p>Looking for more data?</p>
        <a className="btn" href={demoPageUrl} target="_blank" rel="noopener noreferrer">
          Contact us
        </a>
      </div>
    </div>

    <div className="reached-quota-state-footer">
      <p className="text-black text-16 text-center">
        Want insights on the Top 50 public <br /> companies worldwide?
      </p>
      <a className="link-with-angle" href={financeReportPageUrl}>
        Get free company insights
      </a>
    </div>
  </div>
);

ReachedQuotaState.propTypes = {
  isMobileMode: T.string,
};

export default ReachedQuotaState;
